<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="失物" name="first">
        <el-row :gutter="0" type="flex" justify="center">
          <el-col :xs="24" :sm="23" :md="18">
            <lost ref="lost" />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="招领" name="second">
        <el-row :gutter="0" type="flex" justify="center">
          <el-col :xs="24" :sm="23" :md="18">
            <found ref="found" />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="我的失物" name="third">
        <el-row :gutter="0" type="flex" justify="center">
          <el-col :xs="23" :sm="23" :md="18">
            <my-lost ref="mylost" />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="发布失物" name="fourth">
        <el-row :gutter="0" type="flex" justify="center">
          <el-col :xs="20" :sm="23" :md="12">
            <lost-publish ref="lostpublish" />
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { foundIndex, myIndex, read, save } from "@/api/pilotService/lostFound";
import lost from "./lostFound_item/lost.vue";
import Found from "./lostFound_item/found.vue";
import MyLost from "./lostFound_item/myLost.vue";
import LostPublish from "./lostFound_item/lostPublish.vue";
export default {
  components: { lost, Found, MyLost, LostPublish },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      let tabLoad = {
        first: () => {
          this.$refs.lost.load();
        },
        second: () => {
          this.$refs.found.load();
        },
        third: () => {
          this.$refs.mylost.load();
        },
        fourth: () => {
          this.$refs.lostpublish.load();
        },
      };
      tabLoad[tab.name]();
    },
  },
};
</script>

<style scoped>
.container {
  /* padding: 20px; */
  margin: 0 auto;
  background-color: #f9f9f9;
}
.container /deep/ .el-tabs__header {
  /* width: 20%;
  margin: 0 40%;
  padding: 30px; */
  width: auto;
  margin: 0 auto;
  padding: 30px;
  display: table;
  position: inherit;
}
.container /deep/.el-tabs__nav-wrap::after {
  background: none !important;
}
.container /deep/.el-tabs__item{
  padding-left: 6vw;
}
.container /deep/.el-tabs__item.is-active {
  font-weight: 800;
  font-size: 18px;
  color: #32589f;
}
.container /deep/.el-tabs__active-bar {
  background-color: #32589f;
  height: 6px;
  border-radius: 20px;
}
.demo-form-inline {
  padding-right: 1%;
  width: 340px;
}
@media only screen and (max-width: 768px) {
  .container /deep/ .el-tabs__header {
    padding: 15px;
  }
}
</style>